
import { defineComponent } from "vue";

import TileAdminProjects from "@/components/TileAdminProjects.vue";

export default defineComponent({
  components: {
    TileAdminProjects,
  },
});
